import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { MessageDetails } from "./MessageDetails";
import { MessageProfileInfo } from "./MessageProfileInfo";
export var MessageSent = React.memo(function (_a) {
    var messageInfo = _a.messageInfo;
    return (React.createElement("div", { className: "chat-message" },
        React.createElement("div", { className: "" + IdStyles.CoopChatSentContainer },
            React.createElement(MessageDetails, { messageInfo: messageInfo })),
        React.createElement(MessageProfileInfo, { messageInfo: messageInfo })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/MessageSent.tsx
// module id = 2580
// module chunks = 3